const REDIRECT_RSITE = 'redirectRsite'
class HomeController {
  constructor ($window, $state, I18n) {
    'ngInject'
    this.$window = $window
    this.$state = $state
    this.I18n = I18n
    this.redirectRsite()
  }

  redirectRsite () {
    if (this.$window.localStorage && this.$window.localStorage[REDIRECT_RSITE] === 'true') {
      this.$window.localStorage[REDIRECT_RSITE] = 'false'
      return this.$state.go('authentication')
    }
  }
}

export default HomeController



// WEBPACK FOOTER //
// ./src/app/pages/home/home.controller.js